import { PostedJobsPayload } from "src/models/common.model";
import {
  CancelJobPayload,
  EditJobPayload,
  PostJobPayload,
} from "src/models/create.job.model";
import { PutPayloadProps } from "src/models/service.models";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function editJobNotes(params: string, data: PutPayloadProps) {
  return await apiCall.patch(
    API_URL.OFFICE_NOTES.EDIT_OFFICE_NOTES + params,
    data
  );
}

export async function getPostedJobs(params: PostedJobsPayload) {
  return await apiCall.get(API_URL.JOBS.POSTED_JOBS, { ...params });
}
export async function patchPostedJobsPublishReject(
  params: string,
  data: PutPayloadProps
) {
  return await apiCall.patch(API_URL.JOBS.PATCH_JOBS + params, data);
}

export async function getAllOfficeList(
  payload: { [key: string]: string | number | number[] } | undefined
) {
  const res = await apiCall.get(API_URL.JOBS.GET_OFFICE_LIST, payload);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData;
  }
}

export async function createJobByAdmin(data: PostJobPayload) {
  const res = await apiCall.post(API_URL.JOBS.POST_JOB_BY_ADMIN, data);
  return await handleResponse(res);
}

export async function cancelAdminJob(payload: CancelJobPayload, uuid: string) {
  const url = API_URL.JOBS.CANCEL_ADMIN_JOB.replace("jobUuid", uuid).replace(
    /[{}]/g,
    ""
  );
  const res = await apiCall.patch(url, payload);
  const responseData = await handleResponse(res);

  return responseData;
}
export async function updateJobByAdmin(jobUuid: string, data: EditJobPayload) {
  const url = API_URL.JOBS.UPDATE_JOB_BY_ADMIN.replace(
    "jobUuid",
    jobUuid
  ).replace(/[{}]/g, "");
  const res = await apiCall.patch(url, data);
  return await handleResponse(res);
}
